
import { Vue, Component } from "vue-property-decorator";
import dayjs from "dayjs";
@Component({
  name: "editBrand",
})

export default class editBrand extends Vue {
	
  data() {
    return {
		dialogImageUrl: this.$route.query.clogo,
        dialogVisible: false,
		isEdit:false
    }
  };
  private form = {
	  name:this.$route.query.cname,
	  logo:this.$route.query.clogo
  };
  private fileList: Array<any> = [
	  {
	    name: this.$route.query.cname,
	    url: this.$route.query.clogo
	 }
  ];

  private mounted() {
	console.log("品牌管理",this.form);
  }
  private userStateChange(item) {

    // 是否启用
    console.log(item);
  }
  private handleUpdate(index, row){
    // 编辑品牌
    console.log(row);
  }
  private handleRemove(file, fileList) {
    console.log(file, fileList);
  }
  private handlePictureCardPreview(file) {
    this.dialogImageUrl = file.url;
    this.dialogVisible = true;
  }
}
